import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=59ed9062&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=59ed9062&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ed9062",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59ed9062')) {
      api.createRecord('59ed9062', component.options)
    } else {
      api.reload('59ed9062', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=59ed9062&scoped=true&", function () {
      api.rerender('59ed9062', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2X5VA6L14AIik/JS/comp/SearchFilterTokens.vue"
export default component.exports